const products = {
  "Blue Hand Block Printed Sleeveless Top": 999,
  "Blue Leaf Printed Hand Block Printed Cotton Top": 999,
  "Brown Cotton Hand Block Printed Top": 999,
  "Cream Hand Block Printed Sleeveless Top": 999,
  "Green Floral Printed Cotton Hand Block Printed Top": 999,
  "Lavender Embroidered Top": 999,
  "Leaf Green Mix Cotton Hand Block Printed Top": 999,
  "Pink Hand Block Floral Printed Top": 999,
  "Red Floral Hand Block Printed Top": 999,
  "Shirt Style Pure Cotton Top": 999,
  "Tie Dye Pure Cotton Kaftan": 999,
  "White Floral Pure Cotton Top": 999,
  "Blue floral Handblock Kaftan": 2150,
  "Bouncy Beige Floral Handblock Mul Cotton Kaftan": 2150,
  "Cotton Hand Block Floral Print Long Kaftan": 1800,
  "Cotton Hand Block Long Mustard Red Kaftan": 1800,
  "Cotton Hand Block Print Long Kaftan Light Green and Blue Striped": 1800,
  "Cotton Hand Block Print Peach Geometric Kaftan": 1800,
  "Flickering Flames Of Yellow Handblock Printed Cotton Kaftan": 2150,
  "Green Handblock Printed Cotton Kaftan": 2150,
  "Grey Floral Handblock Kaftan": 2150,
  "Maroon & White Handblock Slip-On Kaftan": 2150,
  "Mint Green Handblock Printed Cotton Kaftan": 2150,
  "Peach Floral Handblock Kaftan": 2150,
  "Pink Handblock Printed Cotton Kaftan": 2150,
  "Abstract Waves Black Cord Set": 1900,
  "Black and Pink Stylish Co-ord Set": 1900,
  "Black Khadi Cotton Co-ord Set": 2500,
  "Black Pure Cotton Co-ord Set": 2500,
  "BOBBY PINK PRINTED CO-ORD SET": 1100,
  "Chocolate Brown Pure Cotton Coord-Set": 2500,
  "Classic Navy Stripes Cord Set": 1900,
  "Cotton Jungle Co-ord Set": 1900,
  "Cream Pure Cotton Ikat Co-ord Set": 2500,
  "Cream Pure Cotton Sippy Co-ord Set": 2500,
  "Dusty Rose Semi Formal Co-Ord Set": 1100,
  "FLORAL BLUSH SPAGHETTI SET": 1100,
  "Floral Pink Co-ord Set": 2500,
  "Green Coord Set in Silk with Floral Motifs": 1900,
  "Green Handblock Co-Ord Set": 1900,
  "LIME FLORAL PRINTED CO-ORD SET": 1100,
  "Mehendi Magic Pure Cotton Coord Set": 1900,
  "MINT MARBEL CO-ORD SET": 1100,
  "Petal Yellow Shorts Set": 1100,
  "Pine Pure Cotton Co-ord Set": 1100,
  "Pink Hues Coord Set": 3100,
  "Sun & Moon Pink Embroidered Coord Set": 2900,
  "Tangerine Orange Pure Cotton Co-ord Set": 2500,
  "BLOOMING STRAIGHT-FIT DRESS": 1100,
  "Blue cotton handblock print dress": 1100,
  "DAIZY BLUE SHELL SHORT DRESS": 1100,
  "FARM KEY HOLE MAXI DRESS": 1100,
  "NOIR UTILITY DRESS": 1100,
  "OCEAN BLUE PRINTED SHORT DRESS": 1100,
  "Pink Hand block cotton floral dress": 1100,
  "Solid army green button down dress": 1100,
  "SUMMER ELEGANCE LACE SHORT DRESS": 1100,
  "SWEET GREEN FLORAL MAXI DRESS": 1100,
  "WHITE TIER LONG DRESS": 1100,
  "Amohe Pink Pure Cotton Kurta Set": 1650,
  "Anam Kurta Set": 4500,
  "Baby Pink Pure Cotton Tiny Floral Block Print Kurta Set": 2900,
  "Bella Blue Hand Block Print Cotton Straight Kurta": 1650,
  "Black Pure Cotton Umbrella Block Kurta Set": 2900,
  "BLUE PURE COTTON HEAVY ANARKALI WITH ORGANZA DUPATTA SET": 18000,
  "FAREEN COTTON SHARARA SET": 13000,
  "FLORAL RELAXED FIT KURTA AND PANT ONLY": 1900,
  "GREEN PAISELY COTTON HAND BLOCK ANARKALI SET": 14000,
  "GUL-RANGBIRANGI SUIT SET": 21000,
  "INAYAT BLUE COTTON ANARKALI SET WITH ORGANZA DUPATTA": 16500,
  "MAHI BLUE COTTON SHARARA SET": 15000,
  "Mida Sharara Set": 8100,
  "Peach Blush Bloom Kurta Set": 1900,
  "PURPLE OMBRE MUSLIN SHARARA SET": 20000,
  "Red Floral Block Print Embroidered Suit Set": 5600,
  "Ruhi Kurta Set": 6900,
  "TULSI PINK COTTON HAND BLOCK SKIRT SET WITH SOFT NET DUPATTA": 18000,
  "ZAARA BLUE COTTON SILK SUIT SET WITH ORGANZA DUPATTA": 17500,
  "Lilac Whispers: Light Purple Designer Georgette Embroidered Lehenga Choli": 49999,
  "Yashi Leafy Hand Block Printed A-Line Kurta": 1100,
  "Savri Green Floral Hand Block Kurta Only": 1100,
  "Neerja Floral Handblock Printed A-Line Kurta": 1100,
  "Mahika Ajrakh Handblock Printed A-Line Kurta": 1100,
  "Beige Hand Block Cotton Night Suit": 1500,
  "Blue Hand Block Print Cotton Night Suit": 1500,
  "Green Tone Hand Block Cotton Night Suit": 1500,
  "Light grey Hand Block Cotton Night Suit": 1500,
  "Light Pink Hand Block Cotton Night Suit": 1500,
  "Pink Hand Block Print Cotton Night Suit": 1500,
  "PLAYFUL MULTI-COLOR STRIPE NIGHT SUIT": 1100,
  "SPRING FLORAL PRINT NIGHT SUIT": 1100,
  "White Pure Cotton Night Suit": 1100,
  "YELLOW STRIPE NIGHT SUIT": 1100,
  "3 Piece Set Indian Floral Print Cotton Toiletry Bag": 1500,
  "Blue Cotton Floral Block Print reversible Shopping Bag": 890,
  "Cotton Quilted Tote Bag Animal Printed Large Grocery Bag": 999,
  "Cotton Velvet Market Bag": 999,
  "Handmade Cotton Block Print Duffle Bag": 890,
  "2 Pair Combo of Silver Plated Long Jhumka Earrings": 6600,
  "Blue Meenakari Chandbali Earrings with Maangtikka": 5900,
  "Gold Plated Kundan Red Meenakari Choker Necklace Set": 3230,
  "Gold Plated Meenakari Jhumka Earrings": 3400,
  "Green Meenakari Jhumka with Pearls": 3100,
  "Green Meenakari Kundan Floral Long Chandbali": 4000,
  "Green & Yellow Meenakari Jhumki Earrings": 2800,
  "Beautiful contrast Off-white Cotton Duptta": 300,
  "Green Geomatic Print Style": 300,
  "Hand Block Printed Cotton Square": 500,
  "Hand printed organic cotton blue and white scarf": 500,
  "MAROON COTTON DUPATTA": 400,
  "Mustard Treasure Floral Handblock Kotadori Dupatta": 500,
  "Blue Blossom: Light Blue Georgette Embroidered Wedding Lehenga Choli": 49999,
  "Blush Bloom: Pink Floral Lehenga Set": 40000,
  "Blush Serenity – Embroidered Cotton Mulmul Kurta Set (3-Piece)": 9000,
  "Cream Pure Cotton Stripes Kurta Set": 1900,
  "Crimson Elegance Red Silk Sequins Embroidered Lehenga": 30000,
  "Elegance Reimagined: Off-White Silk Blend Embroidered Lehenga Set": 25000,
  "Elegant Pink A-Line Kurti with Dupatta": 29999,
  "Elegant Red Embroidered Chanderi Kurta & Cotton Pants Set": 9000,
  "Ethereal Radiance: White Georgette Embroidered Lehenga Choli for Timeless Elegance": 49000,
  "Fiery Elegance: Orange Sequin Embroidered Soft Net Lehenga Choli for Party Glam": 40000,
  "Golden Mustard Lehenga Set with Beaded Blouse and Choker Dupatta": 29000,
  "Midnight Allure: Black Georgette Sequin Embroidered Lehenga Choli": 49000,
  "Peach Elegance Georgette Anarkali with Beaded Tassel Dupatta": 29999,
  "PURPLE PURE COTTON ANARKALI SET WITH ORGANZA DUPATTA": 18000,
  "Regal Radiance Silk Thread Embroidered Lehenga": 30000,
  "Rose Bloom Printed Cotton Suit Set with Organza Dupatta – 3 Piece": 9000,
  "Rosé Whisper Chanderi Kurta & Wide-Leg Pant Set": 9000,
  "Royal Allure Purple Thread Embroidered Silk Designer Lehenga": 30000,
  "Royal Bloom: Purple Dola Silk Blend Embroidered Lehenga Set": 25000,
};

const orgDetails = {
  orgName: "RANCH RT PRIVATE LIMITED",
  gstNumber: "07AAKCR9648C1Z1",
  phoneNumber: "+91 9253104986",
  orgAddress:
    "4th floor, 434A Shree Jhule Lal Marg, Shiv Market, Ashok Vihar Phase 1, New Delhi- 110052",
};

const shortName = "RT";

const ranch = { products, orgDetails, shortName };
export default ranch;
